import { Pencil1Icon, TrashIcon } from "@radix-ui/react-icons";
import { useState } from "react";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { Lists } from "../../components/common/Lists";
import TableComponent from "../../components/common/Tables";
import { useAppDispatch } from "../../hooks/hooks";
import { useGetScientificAreasQuery } from "../../hooks/useGetScientificAreasQuery";
import { setUpdateScientificAreaData } from "../../redux/slices/school/scientificArea";
import { routes } from "../../routes";
import { deleteScientificArea } from "../../services/school/scientificArea/deleteScientificArea";
import { ScientificAreaType } from "../../types/ScientificAreas";

const columnNamesMap: { [key: string]: string } = {
    description: 'Descrição',
};
export const ScientificAreas = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const queryClient = useQueryClient();
    const { data, status } = useGetScientificAreasQuery({ PageNumber: currentPage, PageSize: 400 });

    const mutationDelete = useMutation(deleteScientificArea, {
        onSuccess: () => {
            queryClient.invalidateQueries('scientificAreas-pagination');
            toast.success('Apagado');
        },
        onError: () => {
            toast.error("Erro ao apagar.")
        }
    });

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };
    const handleClickCreate = (event: any): void => {
        navigate(routes.createScientificAreas)
    }
    const handleEdit = (scientificArea: ScientificAreaType) => {
        dispatch(setUpdateScientificAreaData(scientificArea));
        navigate(routes.updateScientificAreas)
    };
    const handleDelete = (scientificArea: ScientificAreaType) => {
        mutationDelete.mutateAsync({ id: scientificArea.id })
    };

    const options = data?.items.map(() => [
        {
            label: 'Editar',
            onClick: (scientificArea: ScientificAreaType) => handleEdit(scientificArea),
            icon: <Pencil1Icon />
        },
        {
            label: 'Excluir',
            onClick: (scientificArea: ScientificAreaType) => handleDelete(scientificArea),
            icon: <TrashIcon />
        }
    ]) || [];

    return (
        <Lists
            status={status}
            TableComponent={() =>
                <TableComponent
                    columns={['description']}
                    items={data?.items}
                    options={options}
                    columnNamesMap={columnNamesMap}
                    totalPages={data?.totalPages || 1}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                />
            }
            handleClickCreate={handleClickCreate}
        />
    );
}